// import React, { useEffect, useState } from "react";
// import { Modal } from "antd";
// import { CloseOutlined } from "@ant-design/icons";
// import StepperComponent from "../StepperComponent/StepperComponent";
// import OTPComponent from "../OTPComponent/OTPComponent";
// import ImageUpload from "../ImageUpload/ImageUpload";
// import DomainVerificationIcon from "@mui/icons-material/DomainVerification";
// import UploadFileIcon from "@mui/icons-material/UploadFile";
// import DoneIcon from "@mui/icons-material/Done";
// import "./style.scss";
// import Storelist from "../../Store/Actions";
// import useApiPost from "../../Hooks/usePost";
// import { BASE_URL_API } from "../../appconfig";
// import { toast } from "react-toastify";
// import Api from "../../Utils/Api.js";

// const DropModal = () => {
//   const [step, setStep] = useState(0);
//   const [isStatusChange, setIsStatusChange] = useState(false);
//   const [pickupDone, setPickupDone] = useState(false);
//   const { PageStore, pickUpModal, setLoading, ServiceDetailsStore } =
//     Storelist();
//   const _verifyOTP = useApiPost();
//   const postBeforeImage = useApiPost();
//   const postAfterImage = useApiPost();
//   const statusChange = useApiPost();
//   const serviceDetail = ServiceDetailsStore?.data;
//   const { GetRequestByID } = Api();

//   const stepsConfig = [
//     {
//       label: "Verify OTP",
//       icon: DomainVerificationIcon,
//       component: OTPComponent,
//     },
//     {
//       label: "Upload After Pickup",
//       icon: DoneIcon,
//       component: ImageUpload,
//     },
//   ];

//   useEffect(() => {
//     console.log("pickupModal changed:", PageStore.pickupModal);

//     if (!PageStore.pickupModal) return;

//     const status = serviceDetail?.bikeRequest?.pickupStatus;

//     if (status === "ASSIGNED") {
//       setStep(0);
//     } else if (status === "PICKED-UP") {
//       setStep(1);
//     }
//   }, [PageStore.pickupModal, serviceDetail?.bikeRequest?.pickupStatus]);





//   /**
//    * Switches to the next step in the pickup modal.
//    * If the current step is 0 (Verify OTP), it switches to step 1 (Upload Before Pickup).
//    * If the current step is 1 (Upload Before Pickup), it switches to step 2 (Upload After Pickup).
//    * If the current step is 2 (Upload After Pickup), it closes the pickup modal.
//    */
//   const switchStep = () => {
//     if (step === 0) {
//       setStep(1);
//     } else if (step === 1) {
//       setStep(0);
//       pickUpModal();
//     } else if (step === 2) {
//       setStep(0);
//     }
//   };





//   /**
//    * Verify OTP of a service request.
//    * @param {string} otp - OTP to be verified.
//    */
//   const verifyOtp = (otp) => {
//     setLoading(true);
//     _verifyOTP.Postdata(`${BASE_URL_API()}ServiceVerifyOtp`, true, {
//       serviceId: serviceDetail?.bikeRequest?._id,
//       sotp: otp,
//     });
//   };






//   /**
//    * Handles the response of the verify OTP API call. and do the side effects
//    */
//   useEffect(() => {
//     if (_verifyOTP?.data !== null) {
//       if (_verifyOTP?.data?.status === 200) {
//         _verifyOTP.setData(null);
//         toast.success("OTP verified successfully", {
//           position: "top-center",
//         });
//         statusChangeApi();
//       }
//     } else if (_verifyOTP?.error !== null) {
//       toast.error(
//         _verifyOTP?.error?.message
//           ? _verifyOTP?.error.message
//           : "Something went wrong",
//         {
//           position: "top-center",
//         }
//       );
//       _verifyOTP.setError(null);
//     }
//     setLoading(false);
//   }, [_verifyOTP?.data, _verifyOTP?.error]);






//   /**
//    * Uploads images before pickup to the server.
//    * @param {Array} imageList - list of images to upload
//    */
  





//   /**
//    * Uploads images after pickup to the server.
//    * @param {Array} imageList - list of images to upload
//    */
//   const uploadAfterPickupImage = (imageList) => {
//     setIsStatusChange(true);
//     imageUploadApi(
//       imageList,
//       "postPickup",
//       serviceDetail?.bikeRequest?._id,
//       postAfterImage
//     );
//   };







//   /**
//    * Uploads images before pickup to the server.
//    * @param {Array} imageList - list of images to upload
//    * @param {string} state - state of the service request
//    * @param {string} serviceId - id of the service request
//    */
//   const imageUploadApi = (imageList = [], state, serviceId, apiHookRef) => {
//     setLoading(true);
//     const formData = new FormData();
//     formData.append("serviceId", serviceDetail?.bikeRequest?._id);
//     formData.append("state", state);
//     let i = 0;
//     console.log(imageList.length);
//     imageList.forEach((file) => {
//       formData.append("bikeImage", file);
//     });
//     apiHookRef.Postdata(
//       `${BASE_URL_API()}uploadPickupDropImages`,
//       true,
//       formData
//     );
//   };






//   useEffect(() => {
//     // if (postBeforeImage?.data !== null) {
//     //   if (postBeforeImage?.data?.status === 200) {
//     //     postBeforeImage.setData(null);
//     //     switchStep();
//     //     setPickupDone(true);
//     //   }
//     // } else if (postBeforeImage?.error !== null) {
//     //   toast.error(
//     //     postBeforeImage?.error?.message
//     //       ? postBeforeImage?.error.message
//     //       : "Something went wrong",
//     //     {
//     //       position: "top-center",
//     //     }
//     //   );
//     //   postBeforeImage.setError(null);
//     // }

//     if (postAfterImage?.data !== null) {
//       if (postAfterImage?.data?.status === 200) {
//         postAfterImage.setData(null);
//         statusChangeApi();
//         setPickupDone(true);
//       }
//     } else if (postAfterImage?.error !== null) {
//       toast.error(
//         postAfterImage?.error?.message
//           ? postAfterImage?.error.message
//           : "Something went wrong",
//         {
//           position: "top-center",
//         }
//       );
//       postAfterImage.setError(null);
//     }
//     setLoading(false);
//   }, [postAfterImage?.data, postAfterImage?.error]);








//   /**
//    * Makes an API call to change the status of a service request.
//    * @param {string} ServiceId - id of the service request to change the status of.
//    */
//   const statusChangeApi = () => {
//     setLoading(true);
//     statusChange.Postdata(`${BASE_URL_API()}pickupPersonStatusChange`, true, {
//       serviceId: serviceDetail?.bikeRequest?._id,
//     });
//   };





//   /**
//    * Handles the response of the status change API call. and do the side effects
//    */
//   useEffect(() => {
//     if (statusChange?.data !== null) {
//       if (statusChange?.data?.status === 200) {
//         statusChange.setData(null);
//         GetRequestByID(serviceDetail?.bikeRequest?._id);
//         if (pickupDone) {
//           toast.success("Pickup done successfully", {
//             position: "top-center",
//           });
//         }
//         setPickupDone(false);
//         switchStep();
//       }
//     } else if (statusChange?.error !== null) {
//       toast.error(
//         statusChange?.error?.message
//           ? statusChange?.error.message
//           : "Something went wrong",
//         {
//           position: "top-center",
//         }
//       );
//       statusChange.setError(null);
//     }
//     setLoading(false);
//   }, [statusChange?.data, statusChange?.error]);

//   const VerifyOTP = () => (
//     <>
//       <OTPComponent submitOTP={verifyOtp}></OTPComponent>
//     </>
//   );





//   const UploadAfterPickupIMage = () => (
//     <>
//       <ImageUpload
//         imageCount={1}
//         submitImage={uploadAfterPickupImage}
//         minimumUpload={1}
//       ></ImageUpload>
//     </>
//   );



//   const renderComponent = (step) => {
//     switch (step) {
//       case 0:
//         return <VerifyOTP />;
//       case 1:
//         return <UploadAfterPickupIMage />;
//       default:
//         return null;
//     }
//   };
//   return (
//     <Modal
//       open={PageStore.pickupModal}
//       closable={{ "aria-label": "Custom Close Button" }}
//       maskClosable={false}
//       onCancel={() => {
//         pickUpModal();
//       }}
//       destroyOnHidden={false}
//       closeIcon={
//         <CloseOutlined
//           style={{
//             color: "black",
//             backgroundColor: "#ffffff",
//           }}
//         />
//       }
//       footer={null}
//     >
//       <div className="border  pt-3 flex flex-col justify-center items-center">
//         <StepperComponent
//           activeStep={step}
//           steps={stepsConfig}
//         ></StepperComponent>
//         {renderComponent(step)}
//       </div>
//     </Modal>
//   );
// };

// export default DropModal;



import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import StepperComponent from "../StepperComponent/StepperComponent";
import OTPComponent from "../OTPComponent/OTPComponent";
import ImageUpload from "../ImageUpload/ImageUpload";
import DomainVerificationIcon from "@mui/icons-material/DomainVerification";
import DoneIcon from "@mui/icons-material/Done";
import "./style.scss";
import Storelist from "../../Store/Actions";
import useApiPost from "../../Hooks/usePost";
import { BASE_URL_API } from "../../appconfig";
import { toast } from "react-toastify";
import Api from "../../Utils/Api.js";

const DropModal = () => {
  const [step, setStep] = useState(0);
  const [isStatusChange, setIsStatusChange] = useState(false);
  const [pickupDone, setPickupDone] = useState(false);

  const { PageStore, pickUpModal, setLoading, ServiceDetailsStore } = Storelist();
  const _verifyOTP = useApiPost();
  const postAfterImage = useApiPost();
  const statusChange = useApiPost();
  const serviceDetail = ServiceDetailsStore?.data;
  const { GetRequestByID } = Api();

  const stepsConfig = [
    { label: "Verify OTP", icon: DomainVerificationIcon, component: OTPComponent },
    { label: "Upload After Pickup", icon: DoneIcon, component: ImageUpload },
  ];

  // ------------------------
  // Called only when modal opens
  // ------------------------
  const onPickupModalOpen = () => {
    // setPickupDone(false);
    // setIsStatusChange(false);

    const status = serviceDetail?.bikeRequest?.pickupStatus;
    if (status === "ASSIGNED") setStep(0);
    else if (status === "PICKED-UP") setStep(1);
  };

  useEffect(() => {
    console.log("pickupModal changed:");
    if (!PageStore.pickupModal) return;
    onPickupModalOpen();
  }, [PageStore.pickupModal]);


  // ------------------------
  // Switch steps in modal
  // ------------------------
  const switchStep = () => {
    if (step === 0) setStep(1);
    else if (step === 1) {
      setStep(0);
      pickUpModal();
    }
  };


  // ------------------------
  // OTP verification
  // ------------------------
  const verifyOtp = (otp) => {
    setLoading(true);
    _verifyOTP.Postdata(`${BASE_URL_API()}ServiceVerifyOtp`, true, {
      serviceId: serviceDetail?.bikeRequest?._id,
      sotp: otp,
    });
  };

  useEffect(() => {
    if (_verifyOTP?.data) {
      if (_verifyOTP.data.status === 200) {
        _verifyOTP.setData(null);
        toast.success("OTP verified successfully", { position: "top-center" });
        statusChangeApi();
      }
    } else if (_verifyOTP?.error) {
      toast.error(_verifyOTP.error.message || "Something went wrong", { position: "top-center" });
      _verifyOTP.setError(null);
    }
    setLoading(false);
  }, [_verifyOTP?.data, _verifyOTP?.error]);

  // ------------------------
  // Upload after pickup image
  // ------------------------
  const uploadAfterPickupImage = (imageList) => {
    setIsStatusChange(true);
    imageUploadApi(imageList, "postPickup", serviceDetail?.bikeRequest?._id, postAfterImage);
  };

  const imageUploadApi = (imageList = [], state, serviceId, apiHookRef) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("serviceId", serviceId);
    formData.append("state", state);
    imageList.forEach((file) => formData.append("bikeImage", file));
    apiHookRef.Postdata(`${BASE_URL_API()}uploadPickupDropImages`, true, formData);
  };

  useEffect(() => {
    if (postAfterImage?.data) {
      if (postAfterImage.data.status === 200) {
        postAfterImage.setData(null);
        statusChangeApi();
        setPickupDone(true);
      }
    } else if (postAfterImage?.error) {
      toast.error(postAfterImage.error.message || "Something went wrong", { position: "top-center" });
      postAfterImage.setError(null);
    }
    setLoading(false);
  }, [postAfterImage?.data, postAfterImage?.error]);

  // ------------------------
  // Status change API
  // ------------------------
  const statusChangeApi = () => {
    setLoading(true);
    statusChange.Postdata(`${BASE_URL_API()}pickupPersonStatusChange`, true, {
      serviceId: serviceDetail?.bikeRequest?._id,
    });
  };

  useEffect(() => {
    if (statusChange?.data) {
      if (statusChange.data.status === 200) {
        statusChange.setData(null);
        console.log("status change 2");
        GetRequestByID(serviceDetail?.bikeRequest?._id);

        if (pickupDone) {
          toast.success("Pickup done successfully", { position: "top-center" });
        }
        setPickupDone(false);
        switchStep();
      }
    } else if (statusChange?.error) {
      toast.error(statusChange.error.message || "Something went wrong", { position: "top-center" });
      statusChange.setError(null);
    }
    setLoading(false);
  }, [statusChange?.data, statusChange?.error]);

  // ------------------------
  // Render step components
  // ------------------------
  const renderComponent = (step) => {
    switch (step) {
      case 0:
        return <OTPComponent submitOTP={verifyOtp} />;
      case 1:
        return <ImageUpload imageCount={1} submitImage={uploadAfterPickupImage} minimumUpload={1} />;
      default:
        return null;
    }
  };

  // ------------------------
  // Modal JSX
  // ------------------------
  return (
    <Modal
      open={PageStore.pickupModal}
      closable={{ "aria-label": "Custom Close Button" }}
      maskClosable={false}
      onCancel={pickUpModal}
      destroyOnHidden={false}
      closeIcon={
        <CloseOutlined style={{ color: "black", backgroundColor: "#ffffff" }} />
      }
      footer={null}
    >
      <div className="border pt-3 flex flex-col justify-center items-center">
        <StepperComponent activeStep={step} steps={stepsConfig} />
        {renderComponent(step)}
      </div>
    </Modal>
  );
};

export default DropModal;
